/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Pagination, Select, SelectItem, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import { IconSearch, } from '@tabler/icons-react';
import toast from 'react-hot-toast';
//import moment from 'moment';
import { Constants } from '../../../../utils';
import { TeacherAttendeceService, TeacherTestsService } from '../../../../services';
import { useSelector } from 'react-redux';
import { generatePDF } from './generate-pdf';
import PaidAction from '../../../../components/paid-action';



const MODAL_ACTION = {
  NONE: 0,
  SELECT_LAPSE: 1,
}


const Qualifications = () => {
  const navigate = useNavigate();
  const [modal, setModal] = useState(MODAL_ACTION.NONE);
  const { canResetFilter, data, filterBy, goToPage, isLoading, pagination, reload, lapses, downloadByLapse, schoolYears } = useFetchTable();

  const openModal = (action) => {
    setModal(action);
  }

  const onCloseModal = () => {
    setModal(MODAL_ACTION.NONE);
  }

  const selectLapse = async (lapse) => {
    const res = await downloadByLapse(lapse);
    if (!res) return;
    generatePDF(res)
  }

  return (
    <div>

      <Modal
        size="sm"
        isOpen={modal === MODAL_ACTION.SELECT_LAPSE}
        onClose={onCloseModal}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            return (
              <ModalFilter
                onSelectLapse={selectLapse}
                lapses={lapses}
                onClose={onClose}
              />
            )
          }}
        </ModalContent>
      </Modal>

      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <Filters
        canResetFilter={canResetFilter}
        filterBy={filterBy}
        schoolYears={schoolYears}
        resetFilter={() => reload()}
      />

      <Table
        aria-label="Evaluaciones"
        className='mt-5'
        color="primary"
        topContentPlacement="inside"
        topContent={
          <div className="flex items-center justify-between gap-4">
            <div className=" flex flex-row justify-between items-center gap-4">
              <h3 className="text-xl font-medium">Registro de calificaciones</h3>
            </div>
            <PaidAction>
              <Button
                className="bg-green text-white"
                onPress={() => openModal(MODAL_ACTION.SELECT_LAPSE)}
              >
                Descargar
              </Button>
            </PaidAction>
          </div>
        }
      >
        <TableHeader>
          <TableColumn>Nombre de la materia</TableColumn>
          <TableColumn>Grado</TableColumn>
          <TableColumn>Código</TableColumn>
          {/* <TableColumn>% de evaluaciones</TableColumn> */}
          <TableColumn>Registro de calificaciones</TableColumn>
        </TableHeader>
        <TableBody items={data} emptyContent="No hay resultados">
          {(item) => {
            return (
              <TableRow key={item.id}>
                <TableCell>{item.name}</TableCell>
                <TableCell>{item?.school_grade?.name}</TableCell>
                <TableCell>{item?.code}</TableCell>
                {/* <TableCell>{item?.percent}</TableCell> */}
                <TableCell>
                  <span
                    className="cursor-pointer font-semibold text-sm text-secondary"
                    onClick={() => navigate('/qualifications/create', { state: item })}
                  >
                    Ver
                  </span>
                </TableCell>
              </TableRow>
            )
          }}
        </TableBody>
      </Table>

      <div className="flex w-full justify-center mt-4">
        <Pagination
          showControls
          variant="bordered"
          page={pagination.page}
          total={pagination.pages}
          onChange={goToPage}
        />
      </div>
    </div>
  );
}


const ModalFilter = ({ onSelectLapse, lapses, onClose }) => {

  const [currentLapse, setCurrentLapse] = useState(null);

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Seleccione el lapso a descargar</ModalHeader>
      <ModalBody>
        <Select
          label="Lapso"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          radius="sm"
          classNames={{ label: 'font-semibold' }}
          disallowEmptySelection={true}
          selectedKeys={!!currentLapse ? [currentLapse] : []}
          onSelectionChange={v => setCurrentLapse(v.currentKey)}
        >
          {lapses.map((item) => (
            <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
          ))}
        </Select>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button className='bg-green text-white' onPress={() => onSelectLapse(currentLapse)}>Descargar</Button>
      </ModalFooter>
    </>
  )
}

const Filters = ({ canResetFilter, filterBy, resetFilter, schoolYears }) => {
  const initialFilter = {
    search: '',
    school_year_id: '',
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }

  return (
    <section className="flex mt-10 md:mt-0 flex-col md:flex-row md:items-center gap-5">
      <Input
        label="Nombre o código de la materia"
        labelPlacement='outside'
        className='w-[15rem]'
        placeholder="Escribir"
        startContent={<IconSearch />}
        variant="bordered"
        radius="sm"
        value={form.search}
        onValueChange={v => onChange(v, 'search')}
      />

      <Select
        label="Año escolar"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        className='w-[15rem]'
        radius="sm"
        classNames={{ label: 'font-semibold' }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_year_id ? [form.school_year_id] : []}
        onSelectionChange={v => onChange(v.currentKey, 'school_year_id')}
      >
        {schoolYears.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>

      {canResetFilter && (
        <Button
          variant="light"
          className="text-primaryDark"
          onClick={() => {
            setForm(initialFilter);
            resetFilter();
          }}
        >
          Limpiar filtros
        </Button>
      )}
    </section>
  )
}

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    school_year_id: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const user = useSelector(state => state.user);
  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [lapses, setLapses] = useState([]);
  const [schoolYears, setSchoolYears] = useState([]);
  const [pagination, setPagination] = useState(initialPagination);

  const debounceTime = 500;
  const debounce = useRef();


  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

  const fetchData = async () => {
    try {
      setData([]);
      if (!canFetch) return;
      setCanFetch(false);
      const response = await TeacherTestsService.tests.getSubjects({ ...filters, professor_id: user.id })
      const { data, ...rest } = response;
      setData(data);
      setPagination(rest);
      setCanFetch(true);
    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const getCurrentPagination = () => {
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }

  const getSelects = async () => {
    try {
      const results = await TeacherAttendeceService.attendence.getSelects({ professor_id: user.id });
      setSchoolYears(toSelect(results.school_years));
      setLapses(toSelect(results.lapses));
      setCanFetch(true)

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const canResetFilter = () => {
    const { page, perPage, ...initial } = initialFilters;
    const { page: _, perPage: __, ...current } = filters;
    const initFilter = JSON.stringify(initial);
    const currFilter = JSON.stringify(current);
    return initFilter !== currFilter;
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    else fetchData();
  }


  const downloadByLapse = async (lapseId) => {
    try {
      const response = await TeacherTestsService.tests.generateReport({ professor_id: user.id, school_lapse_id: +lapseId });
      return response;
    } catch (error) {
      toast.error(String(error) || "Ocurrió un error inesperado");
    }
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const filterBy = (value, target) => {
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setCanFetch(true);
      setFilters({ ...filters, page: 1, [target]: value });
    }, debounceTime);
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    getSelects()
  }, [])



  return {
    canResetFilter: canResetFilter(),
    changePerPage,
    data,
    filterBy,
    filters,
    goToPage,
    isLoading: !canFetch,
    pagination,
    reload,
    lapses: filters.school_year_id ? lapses.filter(x => x.school_year_id === +filters.school_year_id) : lapses,
    downloadByLapse,
    schoolYears
  }
}

export default Qualifications;
